'use client';

import { memo } from 'react';

import { type VersionReference, VersionReferenceRow } from '~/components/asset-detail/VersionReferenceRow';
import { SectionLabel } from '~/components/SectionLabel';

export type VideoOptionsSectionProps = {
  showVersionReference: boolean;
  versionReference: VersionReference;
  onVersionReferenceChange: (value: VersionReference) => void;
  /** Whether the Dynamic option is clickable */
  isDynamicEnabled?: boolean;
  /** Section header text. Defaults to "Video Options". */
  sectionLabel?: string;
};

export const VideoOptionsSection = memo(
  ({
    showVersionReference,
    versionReference,
    onVersionReferenceChange,
    isDynamicEnabled = false,
    sectionLabel = 'Video Options',
  }: VideoOptionsSectionProps) => {
    if (!showVersionReference) {
      return null;
    }

    return (
      <div className="flex flex-col gap-3">
        <SectionLabel>{sectionLabel}</SectionLabel>

        <VersionReferenceRow
          isDynamicEnabled={isDynamicEnabled}
          onVersionReferenceChange={onVersionReferenceChange}
          versionReference={versionReference}
        />
      </div>
    );
  },
);

VideoOptionsSection.displayName = 'VideoOptionsSection';
